export default __webpack_public_path__ + "static/comparisons-mission-critical-9a067c4de5964fa9c9ff5e79f28f9f2e.png";